import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Signup from './Signup';
import Login from './Login';
import Main from './Main';
import Navbar from './NavBar';
import { useAuth } from './AuthContext';
import LandingPage from './LandingPage';  
import Home from './Home';
import Contact from './Contact';
import Features from './Features';
import Dashboard from './Dashboard';
// 🚀 Import the New Isolated App Components
import SpaceHome from './spaces/SpaceHome';
import SpaceDashboard from './spaces/SpaceDashboard';
import SpaceMain from './spaces/SpaceMain';
function App() {
  const { isLoggedIn, user } = useAuth();

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={isLoggedIn ? <Navigate to={isLoggedIn && user ? `/main/${user.name}` : '/main'} /> : <Login />} />
        <Route path="/main/:username" element={isLoggedIn ? <Main /> : <Navigate to="/login" />} />
        <Route path="/dashboard/:username" element={isLoggedIn ? <Dashboard /> : <Navigate to="/login" />} />
       {/* 🌐 New Spaces App Routes (Isolated Spinoff) */}
<Route 
  path="/:username/spaces" 
  element={isLoggedIn ? <SpaceHome /> : <Navigate to="/login" />} 
/>

{/* 🌟 DEFAULT LANDING: Manage Page (SpaceMain) */}
<Route 
  path="/:username/spaces/:spaceId" 
  element={isLoggedIn ? <SpaceMain /> : <Navigate to="/login" />} 
/>

{/* 🌟 KANBAN VIEW: Dedicated path for Dashboard */}
<Route 
  path="/:username/spaces/:spaceId/kanban" 
  element={isLoggedIn ? <SpaceDashboard /> : <Navigate to="/login" />} 
/>
      </Routes>
    </Router>
  );
}
export default App;